import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f3255c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-3 d-flex rounded gap-4",
  style: {"background-color":"var(--cor_background_1)","border":"0.5px solid var(--cor_background_2)"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"border-radius":"50%","height":"3rem"},
    src: "https://t3.ftcdn.net/jpg/05/17/79/88/360_F_517798849_WuXhHTpg2djTbfNf0FQAjzFEoluHpnct.jpg",
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "d-flex flex-column gap-1" }
const _hoisted_4 = { class: "d-flex justify-content-between gap-6" }
const _hoisted_5 = {
  key: 0,
  class: "text-wrap m-0"
}
const _hoisted_6 = {
  key: 1,
  class: "textarea-container position-relative"
}
const _hoisted_7 = {
  class: "btn position-absolute bottom-0 end-0 p-1",
  style: {"cursor":"pointer"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M22.5775 13.3851L8.82801 5.25655C7.71087 4.59642 6 5.23702 6 6.86977V13L18 14.9964L6 16.6116V23.123C6 24.5878 7.58978 25.4706 8.82801 24.7362L22.5775 16.6116C23.804 15.8889 23.8079 14.1078 22.5775 13.3851Z",
  fill: "#ED2B46"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "d-flex gap-3 rounded p-3 mt-1",
  style: {"background-color":"#f9f9f9"}
}
const _hoisted_12 = {
  class: "demo-image__preview d-flex gap-3",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_13 = {
  key: 3,
  class: "d-flex gap-3",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_14 = {
  enctype: "multipart/form-data",
  novalidate: ""
}
const _hoisted_15 = { class: "dropbox" }
const _hoisted_16 = ["onChange"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-62f3255c><g clip-path=\"url(#clip0_4401_2273)\" data-v-62f3255c><path d=\"M2.5 18.125C2.5 18.6223 2.69754 19.0992 3.04917 19.4508C3.40081 19.8025 3.87772 20 4.375 20H15.625C16.1223 20 16.5992 19.8025 16.9508 19.4508C17.3025 19.0992 17.5 18.6223 17.5 18.125V5.00001H2.5V18.125ZM13.125 8.12501C13.125 7.95925 13.1908 7.80028 13.3081 7.68306C13.4253 7.56585 13.5842 7.50001 13.75 7.50001C13.9158 7.50001 14.0747 7.56585 14.1919 7.68306C14.3092 7.80028 14.375 7.95925 14.375 8.12501V16.875C14.375 17.0408 14.3092 17.1997 14.1919 17.3169C14.0747 17.4342 13.9158 17.5 13.75 17.5C13.5842 17.5 13.4253 17.4342 13.3081 17.3169C13.1908 17.1997 13.125 17.0408 13.125 16.875V8.12501ZM9.375 8.12501C9.375 7.95925 9.44085 7.80028 9.55806 7.68306C9.67527 7.56585 9.83424 7.50001 10 7.50001C10.1658 7.50001 10.3247 7.56585 10.4419 7.68306C10.5592 7.80028 10.625 7.95925 10.625 8.12501V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V8.12501ZM5.625 8.12501C5.625 7.95925 5.69085 7.80028 5.80806 7.68306C5.92527 7.56585 6.08424 7.50001 6.25 7.50001C6.41576 7.50001 6.57473 7.56585 6.69194 7.68306C6.80915 7.80028 6.875 7.95925 6.875 8.12501V16.875C6.875 17.0408 6.80915 17.1997 6.69194 17.3169C6.57473 17.4342 6.41576 17.5 6.25 17.5C6.08424 17.5 5.92527 17.4342 5.80806 17.3169C5.69085 17.1997 5.625 17.0408 5.625 16.875V8.12501ZM18.125 1.25001H13.4375L13.0703 0.519538C12.9925 0.363372 12.8727 0.232008 12.7243 0.140225C12.576 0.0484421 12.4049 -0.00011828 12.2305 6.84872e-06H7.76562C7.59155 -0.000662313 7.42082 0.047717 7.27297 0.139602C7.12513 0.231487 7.00615 0.363161 6.92969 0.519538L6.5625 1.25001H1.875C1.70924 1.25001 1.55027 1.31585 1.43306 1.43307C1.31585 1.55028 1.25 1.70925 1.25 1.87501L1.25 3.12501C1.25 3.29077 1.31585 3.44974 1.43306 3.56695C1.55027 3.68416 1.70924 3.75001 1.875 3.75001H18.125C18.2908 3.75001 18.4497 3.68416 18.5669 3.56695C18.6842 3.44974 18.75 3.29077 18.75 3.12501V1.87501C18.75 1.70925 18.6842 1.55028 18.5669 1.43307C18.4497 1.31585 18.2908 1.25001 18.125 1.25001Z\" fill=\"#ED2B46\" data-v-62f3255c></path></g><defs data-v-62f3255c><clipPath id=\"clip0_4401_2273\" data-v-62f3255c><rect width=\"20\" height=\"20\" fill=\"white\" data-v-62f3255c></rect></clipPath></defs></svg>", 1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 5.625V16.875C20 17.9102 19.1602 18.75 18.125 18.75H1.875C0.839844 18.75 0 17.9102 0 16.875V5.625C0 4.58984 0.839844 3.75 1.875 3.75H5.3125L5.79297 2.46484C6.06641 1.73437 6.76562 1.25 7.54688 1.25H12.4492C13.2305 1.25 13.9297 1.73437 14.2031 2.46484L14.6875 3.75H18.125C19.1602 3.75 20 4.58984 20 5.625ZM14.6875 11.25C14.6875 8.66406 12.5859 6.5625 10 6.5625C7.41406 6.5625 5.3125 8.66406 5.3125 11.25C5.3125 13.8359 7.41406 15.9375 10 15.9375C12.5859 15.9375 14.6875 13.8359 14.6875 11.25ZM13.4375 11.25C13.4375 13.1445 11.8945 14.6875 10 14.6875C8.10547 14.6875 6.5625 13.1445 6.5625 11.25C6.5625 9.35547 8.10547 7.8125 10 7.8125C11.8945 7.8125 13.4375 9.35547 13.4375 11.25Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, "Editar", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, "Excluir", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "legenda",
  style: {"font-size":"0.75rem !important"}
}
const _hoisted_29 = {
  key: 0,
  class: "d-flex",
  style: {"margin-left":"auto"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"border-radius":"50%","height":"3rem"},
  src: "https://t3.ftcdn.net/jpg/05/17/79/88/360_F_517798849_WuXhHTpg2djTbfNf0FQAjzFEoluHpnct.jpg",
  alt: ""
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tem certeza que deseja excluir este comentário?", -1))
const _hoisted_33 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayComment, (comment, key) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "rounded card",
      key: key
    }, [
      (comment.type === 'comment')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Title, { class: "py-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(comment.username.split(' ').length > 2 ? `${comment.username.split(' ')[0]} ${comment.username.split(' ')[1]}` : comment.username), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              (!comment.edit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(comment.description), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_el_input, {
                      modelValue: comment.description,
                      "onUpdate:modelValue": ($event: any) => ((comment.description) = $event),
                      rows: 4,
                      type: "textarea",
                      placeholder: "Digite...",
                      id: "text-area-comments",
                      resize: "none"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("button", _hoisted_7, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: ($event: any) => (_ctx.saveComment(comment)),
                        width: "30",
                        height: "30",
                        viewBox: "0 0 30 30",
                        fill: "none",
                        xmln: "",
                        s: "http://www.w3.org/2000/svg"
                      }, _hoisted_10, 8, _hoisted_8))
                    ])
                  ])),
              (comment.urls.length > 0 && !comment.edit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.urls, (item, key) => {
                        return (_openBlock(), _createBlock(_component_el_image, {
                          key: key,
                          class: "rounded",
                          style: {"width":"100px","height":"100px","cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.getUrls(comment.urls)),
                          src: item.url,
                          "zoom-rate": 1.2,
                          "max-scale": 7,
                          "min-scale": 0.2,
                          "preview-src-list": _ctx.arrayUrls,
                          "initial-index": key,
                          fit: "cover"
                        }, null, 8, ["onClick", "src", "preview-src-list", "initial-index"]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("form", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("input", {
                          type: "file",
                          ref_for: true,
                          ref: "fileInput2",
                          multiple: "",
                          id: "input-file2",
                          name: "fileUpload2",
                          onChange: (e) => _ctx.filesChange(e, comment.id),
                          accept: "image/*"
                        }, null, 40, _hoisted_16)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.urls, (item, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.url,
                        style: {"position":"relative"}
                      }, [
                        _createVNode(_component_el_image, {
                          class: "rounded",
                          style: {"width":"100px","height":"100px","cursor":"pointer"},
                          src: item.url,
                          "zoom-rate": 1.2,
                          "max-scale": 7,
                          "min-scale": 0.2,
                          "preview-src-list": comment.urls.map((e) => e.url),
                          "initial-index": 0,
                          fit: "cover"
                        }, null, 8, ["src", "preview-src-list"]),
                        _createElementVNode("div", {
                          style: {"position":"absolute","bottom":"10px","right":"4px","cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.removeUrl(comment.urls, key))
                        }, _hoisted_19, 8, _hoisted_17)
                      ]))
                    }), 128)),
                    (comment.edit)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.openInput(comment)),
                          style: {"cursor":"pointer"},
                          class: "d-flex justify-content-center align-items-center"
                        }, _hoisted_22, 8, _hoisted_20))
                      : _createCommentVNode("", true)
                  ])),
              (!_ctx.onlyRead)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(["d-flex gap-3 container-button", [comment.id_cargo === 3 ? 'justify-content-end' : '' ]])
                  }, [
                    (_ctx.user && _ctx.user?.id == comment.id_user)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: () => { comment.edit = !comment.edit, _ctx.uploadedFiles = [] }
                        }, _hoisted_25, 8, _hoisted_23))
                      : _createCommentVNode("", true),
                    (_ctx.user && _ctx.user?.id == comment.id_user)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.centerDialogVisible = true))
                        }, _hoisted_27))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.moment(comment.created_at).format('D/M/YYYY, LT')), 1)
            ]),
            (comment.id_cargo === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.centerDialogVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
        width: "500",
        "align-center": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.centerDialogVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancelar")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: ($event: any) => (_ctx.deleteComment(comment.id, comment.id_ticket))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Excluir ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_32
        ]),
        _: 2
      }, 1032, ["modelValue"])
    ]))
  }), 128))
}